import {modelsFromObject} from '../../helpers/models-from-object.js'

//Take in combatants and get back the order for this series.
export function getOrderedActionsFromSubmissions(combatantModels = {}) {
  const sortedIds = modelsFromObject(combatantModels).map(combatantModel => {
    //Get speed rating + little random decimal for ordering ties.

    //const speedRating = combatantModel.getTotalSpeed() + parseFloat(Math.random().toFixed(1));
    const speedRating = combatantModel.getTotalSpeed(); //No tie breaker

    return {
      _id: combatantModel._id,
      speedRating
    }
  }).sort((a, b) => {
    //Sort the array by calculated speedRating
    return a.speedRating < b.speedRating ? 1 : -1

  }).map(sorted => sorted._id); //Return the sorted IDs in order.

  //Add in initial deadlines
  return sortedIds.map(id => {
    const combatantModel = combatantModels[id];

    if (combatantModel.status === "deadline") {
      return [
        id,
        `deadline::${id}`
      ]
    }

    return [id]

  }).reduce((a, b) => {
    return [...a, ...b]
  });

}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/get-order.js